import { icon } from "../kit/components.ts";
import { h } from "../kit/dom.ts";
import { interactPrompt } from "./interact-model.ts";

/**
 * Rótulo do alvo sob a mira (nome, vida do recurso ou motivo do bloqueio) e, quando ele tem a tecla de
 * interagir, o cartão "interagir" embaixo à direita (F81, mockup ui-b: a mão, o alvo, a ação e a tecla).
 * O `#alvo` guarda o texto inteiro (e2e e leitores de tela); com o cartão à vista, ele sai só da vista.
 * Texto via textContent.
 */
export class GameHud {
  private readonly target: HTMLElement;
  private readonly prompt: HTMLElement;
  private readonly promptTitle: HTMLElement;
  private readonly promptAction: HTMLElement;
  private readonly promptKey: HTMLElement;
  private readonly interactKey: () => string;
  private shown: string | undefined = "";

  /** `interactKey`: o nome da tecla de interagir agora (as Opções remapeiam). */
  constructor(parent: HTMLElement, interactKey: () => string = () => "E") {
    this.interactKey = interactKey;
    this.target = document.createElement("div");
    this.target.id = "alvo";
    this.target.setAttribute("role", "status");
    this.promptTitle = h("strong", { class: "interagir-alvo" });
    this.promptAction = h("span", { class: "interagir-acao" });
    this.promptKey = h("kbd", { class: "interagir-tecla" });
    // O `#alvo` já anuncia o texto: o cartão é só visual.
    this.prompt = h("div", { id: "interagir", class: "hud-cartao", "aria-hidden": "true" }, h("span", { class: "interagir-mao" }, icon("hud-interagir")), h("div", { class: "interagir-corpo" }, this.promptTitle, this.promptAction), this.promptKey);
    this.prompt.hidden = true;
    parent.append(this.target, this.prompt);
    this.setTarget(undefined);
  }

  setTarget(text: string | undefined, blocked = false): void {
    const key = text && `${blocked ? "!" : ""}${text}`;
    if (key === this.shown) return;
    this.shown = key;
    this.target.textContent = text ?? "";
    this.target.classList.toggle("bloqueado", blocked);
    this.target.style.display = text ? "block" : "none";
    const prompt = blocked ? undefined : interactPrompt(text, this.interactKey());
    this.prompt.hidden = !prompt;
    this.target.classList.toggle("com-cartao", !!prompt);
    this.prompt.classList.toggle("segurar", !!prompt?.hold);
    if (!prompt) return;
    this.promptTitle.textContent = prompt.title;
    this.promptAction.textContent = prompt.action;
    this.promptKey.textContent = prompt.key;
  }

  remove(): void {
    this.target.remove();
    this.prompt.remove();
  }
}
